import type { OperatingMode, OperatingModeConfig } from '@atlas-forms/types-js';

const MODE_CONFIGS: Record<OperatingMode, OperatingModeConfig> = {
  edit: {
    mode: 'edit',
    editable: true,
    showValidation: true,
    showHelpText: true,
    allowSubmit: true,
    showRequired: true,
    showReadOnly: true,
    showDisabled: true,
    showHidden: false,
  },
  view: {
    mode: 'view',
    editable: false,
    showValidation: false,
    showHelpText: false,
    allowSubmit: false,
    showRequired: false,
    showReadOnly: true,
    showDisabled: true,
    showHidden: false,
  },
  design: {
    mode: 'design',
    editable: false,
    showValidation: false,
    showHelpText: false,
    allowSubmit: false,
    showRequired: false,
    showReadOnly: true,
    showDisabled: true,
    showHidden: false,
    features: { save: true, publish: true, undo: true, redo: true },
  },
  admin: {
    mode: 'admin',
    editable: true,
    showValidation: true,
    showHelpText: true,
    allowSubmit: true,
    showRequired: true,
    showReadOnly: true,
    showDisabled: true,
    showHidden: true,   // <-- admin sees hidden fields
    features: { save: true, delete: true, export: true, import: true },
  },
  preview: {
    mode: 'preview',
    editable: false,
    showValidation: false,
    showHelpText: true,  // show help in preview
    allowSubmit: false,
    showRequired: true,  // show required indicators
    showReadOnly: true,
    showDisabled: true,
    showHidden: false,
  },
};

export function getModeConfig(mode: OperatingMode): OperatingModeConfig {
  return MODE_CONFIGS[mode] ?? MODE_CONFIGS.edit;
}
